import {normalizeEqualizer} from './equalizer.js';
export const BITRATE_OPTIONS=[8,24,48,96,128,192,256,320];
export const DEFAULT_SETTINGS={countries:[],languages:[],bitrateMin:null,bitrateMax:null,adaptStationArtwork:true,resumePlaybackOnStartup:false,equalizer:normalizeEqualizer()};
export function normalizeSettings(input={}){
  const {bitrates,...settings}=input||{};
  const legacy=Array.isArray(bitrates)?bitrates.filter(n=>Number.isFinite(n)&&n>0):[];
  const explicit=Object.hasOwn(settings,'bitrateMin')||Object.hasOwn(settings,'bitrateMax');
  const min=legacy.length?Math.min(...legacy):null,max=legacy.length?Math.max(...legacy):null;
  return {...DEFAULT_SETTINGS,...settings,
    bitrateMin:explicit?(settings.bitrateMin??null):min===null?null:([...BITRATE_OPTIONS].reverse().find(n=>n<=min)??null),
    bitrateMax:explicit?(settings.bitrateMax??null):max===null?null:(BITRATE_OPTIONS.find(n=>n>=max)??null),
    resumePlaybackOnStartup:settings.resumePlaybackOnStartup===true,
    equalizer:normalizeEqualizer(settings.equalizer),
  };
}
export function changeBitrateBound(range,key,value){
  const next={bitrateMin:range.bitrateMin??null,bitrateMax:range.bitrateMax??null,[key]:value};
  if(next.bitrateMin!==null&&next.bitrateMax!==null&&next.bitrateMin>next.bitrateMax){
    if(key==='bitrateMin')next.bitrateMax=value;else next.bitrateMin=value;
  }
  return next;
}
export function withinBitrate(station,min,max){
  if(min==null&&max==null)return true;
  const bitrate=Number(station.bitrate);
  return bitrate>0&&(min==null||bitrate>=min)&&(max==null||bitrate<=max);
}
export function matchesPreferences(station,settings,genre='All'){
  return (genre==='All'||station.tags?.toLowerCase().split(',').includes(genre.toLowerCase()))&&
    (!settings.countries.length||settings.countries.includes(station.countrycode))&&
    (!settings.languages.length||settings.languages.some(l=>station.language?.toLowerCase().split(',').map(s=>s.trim()).includes(l.toLowerCase())))&&
    withinBitrate(station,settings.bitrateMin,settings.bitrateMax);
}
export function isHD(station){const bitrate=Number(station?.bitrate);return Number.isFinite(bitrate)&&bitrate>=128;}
